export default "/public/dist/img/Certificazionefoto_1.jpg";